import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Generated98d4nnzxvbxu as Generated,
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import {
  Companion_instancecl4qgzq2gv8j as Companion_instance,
  Companion_getInstance2ckxqlwfswrwh as Companion_getInstance,
  Companion_instance1a446aeu2q07d as Companion_instance_0,
} from './notificationModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_TimeInZone__properties() {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return TimeInZone__properties;
}
var TimeInZone__properties;
var TimeInZone_time;
var TimeInZone_zone;
function get_Frequency__properties() {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return Frequency__properties;
}
var Frequency__properties;
var Frequency_onlyAt;
var Frequency_onlyOn;
var Frequency_batchMinutes;
var Frequency_delay;
function get_SendInfo__properties() {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return SendInfo__properties;
}
var SendInfo__properties;
var SendInfo_sendAt;
var SendInfo_sent;
function get_user(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return _this__u8e3s4.prop(get_fieldUser(_this__u8e3s4.get_serializer_u29zhh_k$()));
}
function get_read(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return _this__u8e3s4.prop(get_fieldRead(_this__u8e3s4.get_serializer_u29zhh_k$()));
}
function get_createdAt(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return _this__u8e3s4.prop(get_fieldCreatedAt(_this__u8e3s4.get_serializer_u29zhh_k$()));
}
function get_fieldUser(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return new (Generated())(isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : THROW_CCE(), 2);
}
function get_fieldRead(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return new (Generated())(isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : THROW_CCE(), 5);
}
function get_fieldCreatedAt(_this__u8e3s4) {
  _init_properties_ModelFields_2090458501_kt__bnupk1();
  return new (Generated())(isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : THROW_CCE(), 4);
}
var properties_initialized_ModelFields_2090458501_kt_v8v1en;
function _init_properties_ModelFields_2090458501_kt__bnupk1() {
  if (!properties_initialized_ModelFields_2090458501_kt_v8v1en) {
    properties_initialized_ModelFields_2090458501_kt_v8v1en = true;
    TimeInZone__properties = ensureNotNull(get_serializableProperties(Companion_instance.serializer_9w0wvi_k$()));
    var tmp = get_TimeInZone__properties()[0];
    TimeInZone_time = isInterface(tmp, SerializableProperty()) ? tmp : THROW_CCE();
    var tmp_0 = get_TimeInZone__properties()[1];
    TimeInZone_zone = isInterface(tmp_0, SerializableProperty()) ? tmp_0 : THROW_CCE();
    Frequency__properties = ensureNotNull(get_serializableProperties(Companion_getInstance().serializer_9w0wvi_k$()));
    var tmp_1 = get_Frequency__properties()[0];
    Frequency_onlyAt = isInterface(tmp_1, SerializableProperty()) ? tmp_1 : THROW_CCE();
    var tmp_2 = get_Frequency__properties()[1];
    Frequency_onlyOn = isInterface(tmp_2, SerializableProperty()) ? tmp_2 : THROW_CCE();
    var tmp_3 = get_Frequency__properties()[2];
    Frequency_batchMinutes = isInterface(tmp_3, SerializableProperty()) ? tmp_3 : THROW_CCE();
    var tmp_4 = get_Frequency__properties()[3];
    Frequency_delay = isInterface(tmp_4, SerializableProperty()) ? tmp_4 : THROW_CCE();
    SendInfo__properties = ensureNotNull(get_serializableProperties(Companion_instance_0.serializer_9w0wvi_k$()));
    var tmp_5 = get_SendInfo__properties()[0];
    SendInfo_sendAt = isInterface(tmp_5, SerializableProperty()) ? tmp_5 : THROW_CCE();
    var tmp_6 = get_SendInfo__properties()[1];
    SendInfo_sent = isInterface(tmp_6, SerializableProperty()) ? tmp_6 : THROW_CCE();
  }
}
//region block: exports
export {
  get_createdAt as get_createdAt1oxi5pjv9saww,
  get_read as get_read2fqnxj4c930ns,
  get_user as get_usersuhqswqrijs4,
};
//endregion

//# sourceMappingURL=ModelFields-2090458501.mjs.map
